module.exports = "pegasus/assets/background-patterns/theme6_theme.gif";